import React, { useState } from "react";

const ashrayaColors = {
    Shraddavan: "#5906f5ff",
    Sevaka: "#0d6efd",
    Sadhaka: "#ffc107",
    Vandana: "#198754",
    Upasaka: "#fd7e14",
    Charanashraya: "#dc3545",
    Initiated: "#c92091ff",
};

const ashrayaShortNames = {
    Shraddavan: "SHR",
    Sevaka: "SEV",
    Sadhaka: "SAD",
    Vandana: "VAN",
    Upasaka: "UPA",
    Charanashraya: "CHA",
    Initiated: "INI",
};

const ASHRAYA_ORDER = ["Shraddavan", "Sevaka", "Sadhaka", "Vandana", "Upasaka", "Charanashraya", "Initiated"];

export default function AshrayaWiseReport({ data, getTodayDate, onClose }) {
    const [isOpen, setIsOpen] = useState(!!data);
    if (!data || !isOpen) return null;

    const closeReport = () => {
        setIsOpen(false);
        onClose && onClose();
    };

    const rawTotals = data.ashrayaHash || {};
    const ashrayaTotals = ASHRAYA_ORDER.map((level) => ({
        level,
        count: rawTotals[level] || 0,
    }));

    const maxValue = Math.max(...ashrayaTotals.map((i) => i.count), 1);

    return (
        <div style={{ textAlign: "center" }}>
            <div
                style={{
                    position: "relative",
                    background: "#f8f9fa",
                    padding: 20,
                    borderRadius: 12,
                    border: "1px solid #dee2e6",
                    maxWidth: "100%",
                    margin: "20px auto 0",
                    boxSizing: "border-box",
                }}
            >
                <button
                    onClick={closeReport}
                    style={{
                        position: "absolute",
                        top: 14,
                        right: 14,
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        border: "none",
                        cursor: "pointer",
                        fontSize: 18,
                        fontWeight: "bold",
                        background: "#fff",
                        boxShadow: "0 2px 4px rgba(0,0,0,.15)",
                    }}
                >
                    ×
                </button>

                <h3 style={{ marginBottom: 4 }}>📊 Ashraya Wise Attendance</h3>
                <div style={{ color: "#666", fontSize: 14, marginBottom: 20 }}>{getTodayDate()}</div>

                <div
                    style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "center",
                        gap: 8,
                        height: 260,
                        background: "#fff",
                        border: "1px solid #e9ecef",
                        borderRadius: 8,
                        padding: 14,
                        overflowX: "auto",
                    }}
                >
                    {ashrayaTotals.map(({ level, count }) => {
                        const height = Math.max((count / maxValue) * 180, 18);
                        return (
                            <div key={level} style={{ display: "flex", flexDirection: "column", alignItems: "center", width: 50 }}>
                                <div style={{ fontWeight: "bold", fontSize: 12 }}>{count}</div>
                                <div
                                    style={{
                                        width: 35,
                                        height,
                                        background: ashrayaColors[level] || "#6c757d",
                                        borderRadius: "6px 6px 0 0",
                                    }}
                                />
                                <div style={{ marginTop: 6, fontSize: 10, fontWeight: 600, textAlign: "center", lineHeight: "12px", maxWidth: 50, wordBreak: "break-word" }}>
                                    {ashrayaShortNames[level]}
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div style={{ marginTop: 14, padding: 10, background: "#d1ecf1", borderRadius: 6, fontWeight: "bold", color: "#0c5460" }}>
                    Overall Total: {data.overallTotal}
                </div>
            </div>
        </div>
    );
}
